// @todo: will be replaced with a proper badge component later
export const CryptoPerpBadge = () => (
  <span className="rounded-md bg-zinc-300 px-1.5 py-0.5 font-semibold text-[0.72rem] text-zinc-900 uppercase">
    Crypto Perp
  </span>
);

export default CryptoPerpBadge;
